/*
  Reloads collapsible_tab contents marked with [data-variant-reload] when a new variant is selected.
  - Listens to PUB_SUB_EVENTS.variantChange (published by product-info.js)
  - Fetches the same section HTML with ?variant=<id>&section_id=<section>
  - Replaces only targeted blocks, preserving <details> open state
*/
(function() {
  // Update only targeted blocks using the HTML already fetched by product-info.js
  function updateBlocksFromHtml(productInfo, html, sectionId, variantId) {
    if (!productInfo || !html) return;
    productInfo.querySelectorAll('[data-variant-reload="true"]').forEach((block) => {
      if (!block.id) return;
      const updated = html.getElementById(block.id);
      if (!updated) return;
      const parentDetails = block.closest('details');
      const wasOpen = !!parentDetails?.open;
      block.innerHTML = updated.innerHTML;
      if (parentDetails && wasOpen) parentDetails.open = true;
      block.dispatchEvent(new CustomEvent('variant-collapsible-updated', {
        bubbles: true,
        detail: { variantId, sectionId }
      }));
    });
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
      const { sectionId, html, variant } = evt.data || {};
      if (!sectionId || !html) return;
      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      updateBlocksFromHtml(productInfo, html, sectionId, variant?.id);
    });
  }
})();
